import React from "react";
import { useContext } from "react";
import { useSelector } from "react-redux";
import DeleteIcon from "../../../commonComponents/deleteIcon";
import { ActorContext } from "./Actors/actorProvider";
 const ActorDetailHeader = ({
    actorType,
    title,
    isExpanded,
    boxNumber
 }) => {
 const name = useSelector((state) => state.Actor[actorType]?.name || "");
 const id = useSelector((state) => state.Actor[actorType]?.id|| "");
 

 const actorDetails = useContext(ActorContext)
 const {deletePartiesActor} = actorDetails
 
    return (
       <div>
        {
        
             boxNumber && <span style={{verticalAlign:"middle"}} className="ui black label input-box-number">
                 {boxNumber}
                </span>
                
        }
           {title}
           {!isExpanded && <strong>&nbsp;{name}</strong> }
           {isExpanded && id && deletePartiesActor && <DeleteIcon onClick={()=>{
              if (!window.confirm(`Are you sure to delete actor`))
              return
              deletePartiesActor({actorType,id})
            
            }} /> }   
       </div>
     );
}


export default ActorDetailHeader
